import { HttpErrorResponse } from '@angular/common/http';
import { createAction, props } from '@ngrx/store';

import { Product } from '../../../shared/models';
import { UpsertProductResponse } from '../../services/product-service.model';

export const loadData = createAction('[Product] Load Data');
export const clearProductState = createAction('[Product] Clear Product State');

export const loadProductsRequest = createAction('[Product] Load Products Request');
export const loadProductsSuccess = createAction(
  '[Product] Load Products Success',
  props<{ products: Product[] }>(),
);
export const loadProductsError = createAction(
  '[Product] Load Products Error',
  props<{ error: Error }>(),
);

export const setSelectedProductRequest = createAction(
  '[Product] Set Selected Product Request',
  props<{ id: number }>(),
);
export const setSelectedProductSuccess = createAction(
  '[Product] Set Selected Product Success',
  props<{ product: Product }>(),
);
export const setSelectedProductError = createAction(
  '[Product] Set Selected Product Error',
  props<{ error: Error }>(),
);

export const getProductsRequest = createAction('[Product] Get Products Request');
export const getProductsSuccess = createAction(
  '[Product] Get Products Success',
  props<{ products: Product[] }>(),
);
export const getProductsError = createAction(
  '[Product] Get Products Error',
  props<{ error: Error }>(),
);

export const upsertProductRequest = createAction(
  '[Product] Upsert Product Request',
  props<{ request: Product }>(),
);
export const upsertProductSuccess = createAction(
  '[Product] Upsert Product Success',
  props<{ response: UpsertProductResponse }>(),
);
export const upsertProductError = createAction(
  '[Product] Upsert Product Error',
  props<{ error: Error }>(),
);

export const deleteProductRequest = createAction(
  '[Product] Delete product request',
  props<{ productId: number }>(),
);
export const deleteProductWithConfirmation = createAction(
  '[Product] Confirm Delete product',
  props<{ productId: number }>(),
);
export const deleteProductSuccess = createAction(
  '[Product] Delete product success',
  props<{ productId: number }>(),
);

export const deleteProductFailed = createAction(
  '[Feed-Advice] Delete product failed',
  props<{ error: HttpErrorResponse }>(),
);

export const setSelectedCountryRequest = createAction(
  '[Product] Set selected country request',
  props<{ id: string }>(),
);
export const setSelectedCountrySuccess = createAction(
  '[Product] Set selected country success',
  props<{ id: string; products: Product[] }>(),
);

export const loadSelectedCountryRequest = createAction('[Product] Load selected country request');
export const loadSelectedCountrySuccess = createAction(
  '[Product] Load selected country success',
  props<{ id: string }>(),
);
